import type {
  IGetOrgBillingModelParams,
  IGetOrgBillingModelRequest,
  IGetOrgBillingModelResponse,
} from '@/app-package';
import type { SupraSubscriptionProductBillingModel } from '@bb/domain/dist/types';
import axios from 'axios';

/**
 * GET request to determine an org's billing product model in the backend.
 * (i.e. whether their board has an org lease or a keyholder lease.)
 * @param orgId - The ID of the brokerage whose board we want to get the billing model of.
 * @returns SupraSubscriptionProductBillingModel
 */
const getOrgBillingModel = async ({
  orgId,
}: IGetOrgBillingModelParams): Promise<SupraSubscriptionProductBillingModel> => {
  const config: IGetOrgBillingModelRequest = {
    url: `/supra/billing_model/${orgId}`,
    method: 'get',
  };
  const { data } = await axios.request<IGetOrgBillingModelResponse>(config);
  return data.billingModel;
};

export default getOrgBillingModel;
